import { render } from "./ResizeObserver.vue?vue&type=template&id=be805da8&scoped=true"
import script from "./ResizeObserver.vue?vue&type=script&lang=js"
export * from "./ResizeObserver.vue?vue&type=script&lang=js"

import "./ResizeObserver.vue?vue&type=style&index=0&id=be805da8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-be805da8"

export default script